import React, { useEffect, useState } from 'react';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SeletorData from '../seletorDatas/seletorData';

export type MaskType = "cnpjCpf" | "dataLancamento" | "nome" | "nroPedido" | /* "total" | */ "agentes" | "codAgente" | "logradouro" | "bairro" | "fone" | "ativo" | "nroDocumentoPedido";

export function aplicarMascara(tipo: MaskType | null, valor: string): string | null {
    if (!valor) return null;
    if (!tipo) return valor;
    switch (tipo) {
        case "cnpjCpf": {
            let v = valor.replace(/\D/g, "");
            if (v.length <= 11) {
                // CPF: 000.000.000-00
                v = v.replace(/(\d{3})(\d)/, "$1.$2");
                v = v.replace(/(\d{3})(\d)/, "$1.$2");
                v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
            } else {
                // CNPJ: 00.000.000/0000-00
                v = v.replace(/^(\d{2})(\d)/, "$1.$2");
                v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
                v = v.replace(/(\d{4})(\d)/, "$1-$2");
            }
            return v;
        }

        case "dataLancamento": {
            let v = valor.replace(/\D/g, "");
            v = v.replace(/(\d{2})(\d)/, "$1/$2");
            v = v.replace(/(\d{2})(\d)/, "$1/$2");
            return v;
        }

        case "nome":
            return valor.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");

        case "logradouro":
            return valor.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");

        case "bairro":
            return valor.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");

        case "nroPedido":
            return valor.replace(/\D/g, "");

        case "codAgente":
            return valor;

        case "fone": {
            {/* const original = valor.trim();
            let v = valor.replace(/\D/g, "");

            const temCodigoInternacional =
                original.startsWith("+55") || (v.startsWith("55") && v.length > 12);

            if (temCodigoInternacional) {
                // Remove o 55 apenas se confirmado ser um número internacional completo
                v = v.replace(/^55/, "");

                if (v.length > 10) {
                    // Celular internacional: +55 (99) 99999-9999
                    v = v.replace(/^(\d{2})(\d)/, "+55 ($1) $2");
                    v = v.replace(/(\d{5})(\d)/, "$1-$2");
                } else {
                    // Fixo internacional: +55 (99) 9999-9999
                    v = v.replace(/^(\d{2})(\d)/, "+55 ($1) $2");
                    v = v.replace(/(\d{4})(\d)/, "$1-$2");
                }
            } else {
                if (v.length > 10) {
                    // Celular nacional: (99) 99999-9999
                    v = v.replace(/^(\d{2})(\d)/, "($1) $2");
                    v = v.replace(/(\d{5})(\d)/, "$1-$2");
                } else {
                    // Fixo nacional: (99) 9999-9999
                    v = v.replace(/^(\d{2})(\d)/, "($1) $2");
                    v = v.replace(/(\d{4})(\d)/, "$1-$2");
                }
            }
            */}
            return valor;
        }

        /* case "total": {
            let v = valor.replace(/\D/g, "");
            if (!v) return "";
            let numberValue = parseInt(v, 10).toString();
            if (isNaN(Number(numberValue))) numberValue = "0";
            while (numberValue.length < 3) numberValue = "0" + numberValue;
            let integerPart = numberValue.slice(0, -2);
            let decimalPart = numberValue.slice(-2);
            integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return integerPart + "," + decimalPart;
        } */

        default:
            return valor;
    }
}

function somenteData(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

const placeholders: Record<MaskType, string> = {
    cnpjCpf: "Digite o CNPJ ou CPF",
    dataLancamento: "DD/MM/AAAA",
    nome: "Digite o nome",
    nroPedido: "Digite o número do pedido",
    codAgente: "Digite o código do agente",
    /*  total: "R$ 0,00", */
    agentes: "Digite sua busca ...",
    logradouro: "Digite o Logradouro",
    bairro: "Digite o bairro",
    fone: "Digite o telefone",
    ativo: "ATIVO / INATIVO",
    nroDocumentoPedido: "Digite o número do Ped. Odin"
};

interface MyTextFieldProps {
    tipo: MaskType | null;
    value: string;
    onValueChange: (valor: string) => void;
    onClear: () => void;
    children?: React.ReactNode;
    placeholder?: string;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const MyTextField: React.FC<MyTextFieldProps> = ({
    tipo,
    value,
    onValueChange,
    onClear,
    placeholder,
    onKeyDown,
}) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value;
        const masked = aplicarMascara(tipo, raw) ?? "";
        onValueChange(masked);
    };

    useEffect(() => {
        if (tipo === "dataLancamento" && !value) {
            const hoje = new Date();
            const semanaAtras = new Date();
            semanaAtras.setDate(hoje.getDate() - 7);

            const format = (d: Date) => d.toISOString().slice(0, 10);
            onValueChange(`${format(semanaAtras)}|${format(hoje)}`);
        }
    }, [tipo]);

    const [datas, setDatas] = useState(() => {
        const de = new Date();
        de.setDate(de.getDate() - 7);
        const ate = new Date();
        return { de, ate };
    });

    const resetDatas = () => {
        const de = new Date();
        de.setDate(de.getDate() - 7);
        const ate = new Date();
        setDatas({ de, ate });
        onValueChange(`${de.toISOString().slice(0, 10)}|${ate.toISOString().slice(0, 10)}`);
    };

    const renderInput = () => {
        if (tipo === "dataLancamento") {
            return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <SeletorData
                        value={datas}
                        onChange={({ de, ate }) => {
                            if (de && ate && somenteData(de) > somenteData(ate)) {
                                console.log(de, ate);
                                alert("A data inicial não pode ser maior que a data final.");
                                resetDatas();
                                return;
                            }
                            setDatas({ de: de!, ate: ate! });
                            const format = (d: Date | null) => d ? d.toISOString().slice(0, 10) : "";
                            onValueChange(`${format(de)}|${format(ate)}`);
                        }}
                    />
                    <IconButton
                        onClick={() => {
                            resetDatas();
                            onClear();
                        }}
                        size="small"
                    >
                        <ClearIcon fontSize="small" />
                    </IconButton>
                </Box>
            );
        }
        if (tipo === 'ativo') {
            return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <FormControl variant="outlined" >
                        <InputLabel id="status-label" sx={{
                            textAlign: "center",
                            top: "-6px",
                        }}>Status</InputLabel>
                        <Select
                            labelId="status-label"
                            label="Status"
                            value={value}
                            sx={{ width: 110, textAlign: 'center' }}
                            disabled={!tipo}
                            onChange={(e) => {
                                const value = e.target.value.trim();
                                onValueChange(value);
                            }}
                            size="small"
                        >
                            <MenuItem key="ativo" value="ATIVO">
                                ATIVO
                            </MenuItem>
                            <MenuItem key="inativo" value="INATIVO">
                                INATIVO
                            </MenuItem>
                        </Select>
                    </FormControl>

                    <IconButton
                        onClick={() => {
                            onClear();
                        }}
                        size="small"
                    >
                        <ClearIcon fontSize="small" />
                    </IconButton>
                </Box>
            )
        }

        return (
            <TextField
                fullWidth
                value={value as string}
                onChange={handleChange}
                placeholder={placeholder ?? (tipo ? placeholders[tipo] : "Digite sua busca...")}
                disabled={!tipo}
                onKeyDown={onKeyDown}
                size="small"
                sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } , fontSize: '13px'}}
                InputProps={{
                    endAdornment: value && (
                        <IconButton aria-label="Limpar" onClick={onClear} size="small">
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    ),
                }}
            />
        );
    };

    return (
        <Box sx={{ width: "100%", ".MuiInputBase-root": { fontSize: '14px',backgroundColor: "#fff" } }}>
            {renderInput()}
        </Box>
    );
};

export default MyTextField;

